<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5893 11.9165L14.5818 11.979C12.7493 11.0663 12.5576 10.9447 12.321 11.2994C12.1568 11.5451 11.6785 12.1022 11.5343 12.2671C11.3885 12.4295 11.2435 12.442 10.996 12.3295C10.746 12.2046 9.94345 11.9423 8.99345 11.0929C8.25345 10.4309 7.75678 9.61892 7.61012 9.3691C7.36595 8.94772 7.87678 8.88776 8.34178 8.00838C8.42512 7.8335 8.38262 7.69609 8.32095 7.57201C8.25845 7.4471 7.76095 6.22295 7.55262 5.73495C7.35262 5.24863 7.14678 5.31025 6.99262 5.31025C6.51262 5.26861 6.16178 5.27527 5.85261 5.59672C4.50761 7.07402 4.84678 8.59797 5.99762 10.2185C8.25928 13.1765 9.46428 13.7211 11.6676 14.4772C12.2626 14.6663 12.8051 14.6396 13.2343 14.578C13.7126 14.5022 14.7068 13.9776 14.9143 13.3905C15.1268 12.8034 15.1268 12.3162 15.0643 12.2038C15.0026 12.0914 14.8393 12.0289 14.5893 11.9165Z"
    />
    <path
      d="M17.1 2.874C10.6925 -3.31587 0.0883333 1.17351 0.0841667 9.90578C0.0841667 11.6512 0.541667 13.3534 1.41333 14.8565L0 19.9879L5.27917 18.6122C11.8667 22.1681 19.9967 17.4464 20 9.91077C20 7.26594 18.9667 4.77684 17.0875 2.90647L17.1 2.874ZM18.335 9.88329C18.33 16.2397 11.3475 20.2095 5.825 16.965L5.525 16.7868L2.4 17.5988L3.2375 14.5634L3.03833 14.2511C-0.398333 8.78406 3.55 1.63902 10.06 1.63902C12.2717 1.63902 14.3475 2.50092 15.9108 4.06234C17.4733 5.61043 18.335 7.68482 18.335 9.88329Z"
    />
  </svg>
</template>

<script>
export default {
  name: "WhatsappIcon",
};
</script>
